<template>
  <div v-if="authorized">
    <AddMerchantForm></AddMerchantForm>
    <KTPortlet v-if="merchants && showList" title="Merchants">
      <template v-slot:body>
        <v-data-table
          :item-class="rowClass"
          :headers="headers"
          :items="merchants"
          :items-per-page="10"
          :loading="loading"
          class="elevation-1"
        >
          <template v-slot:loading>
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </template>
          <template v-slot:item.actions="{ item }">
            <p>
              <b-link @click="toggleMerchantFeatures(item.aliasCode)"
                >Toggle Features</b-link
              >
            </p>
          </template>
        </v-data-table>
      </template>
    </KTPortlet>
    <MerchantFeatures
      v-if="selectedMerchant"
      :tenantAlias="selectedMerchant"
      @back="this.exitMerchantFeatures"
    />
  </div>
</template>
<style></style>
<script>
import AddMerchantForm from "@/components/forms/AddMerchantForm";
import MerchantFeatures from "@/components/forms/MerchantFeatures.vue";
import KTPortlet from "@/views/partials/content/Portlet";
import { API, Auth } from "aws-amplify";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";

export default {
  data: () => {
    return {
      merchants: [],
      selectedMerchant: null,
      showList: true,
      headers: [
        { text: "Merchant", value: "aliasCode", align: "center" },
        { text: "Contant Email", value: "email", align: "center" },
        { text: "", value: "actions", sortable: false, align: "center" }
      ]
    };
  },
  components: {
    AddMerchantForm,
    MerchantFeatures,
    KTPortlet
  },
  computed: {
    loading() {
      return (!this.merchants || !this.merchants.length) && this.authorized;
    },
    authorized() {
      return this.$role.verify(["Admin"]);
    }
  },
  methods: {
    rowClass() {
      const rowClass = "table-rows";
      return rowClass;
    },
    async getMerchants() {
      if (!this.authorized) return null;
      let payload = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `${(await Auth.currentSession())
            .getIdToken()
            .getJwtToken()}`
        }
      };

      return await API.get("AdminQueries", "/listMerchants", payload);
    },
    toggleMerchantFeatures(aliasCode) {
      this.selectedMerchant = aliasCode;
      this.showList = false;
    },
    exitMerchantFeatures() {
      this.selectedMerchant = null;
      this.showList = true;
    }
  },
  mounted: async function() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Merchant Management" }]);
    this.merchants = await this.getMerchants();
  }
};
</script>
